import {Configuration} from '@shared/models/configuration';


// @dynamic
export class EntityChartConfig {
  private static get FootprintApi(): string {
    return Configuration.FootprintApi;
  }
  static get EntityChartImportApi(): string {
    return `${EntityChartConfig.FootprintApi}ImportEntityChart`;
  }

  static get EntityCountByCountry(): string {
    return `${Configuration.getConfig('EntityChartApi')}Entity/EntityCountByCountry?projectId=[PROJECT_ID]`;
  }

  static get EntitySettingsApi(): string {
    return `${EntityChartConfig.FootprintApi}EntitySettings?projectId=[PROJECT_ID]`;
  }

  static get EntityChartProjectTopicsApi(): string {
    return `${EntityChartConfig.FootprintApi}ChangeReportTopicSettings/ProjectTopics?projectId=[PROJECT_ID]&isCrossBorder=false`;
  }

  static get EntityChartAddEntityApi(): string {
    return `${EntityChartConfig.FootprintApi}EntitySettings/AddEntity`;
  }

  static get ResetEntitiesFromProjectSettingsApi(): string {
    return `${EntityChartConfig.FootprintApi}EntitySettings/ResetFromProjectSettings`;
  }

  static get EntityChartDeleteEntityApi(): string {
    return `${EntityChartConfig.FootprintApi}EntitySettings/DeleteEntity`;
  }

  static get EntitySettingsGroupByRegionApi(): string {
    return `${EntityChartConfig.FootprintApi}EntitySettings/GroupByRegion?projectId=[PROJECT_ID]`;
  }

  static get PostProjectTopicsApi(): string {
    return `${EntityChartConfig.FootprintApi}ChangeReportTopicSettings/ProjectTopics`;
  }

  static get ApplicationId(): string {
    return Configuration.ApplicationId;
  }

  static get EntityCountApi(): string {
    return `${EntityChartConfig.FootprintApi}EntitySettings/EntityCount?projectId=[PROJECT_ID]`;
  }

  static get EntityChartUrl(): any {
    return [{outlets: {'primary': 'footprint/entity-chart', 'top-toolbar': 'entity-chart-toolbar'}}];
  }
}


